import React from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
    return (
        <>
        <div className="error-wrapper">
        <div className="container"><img className="img-100" src="../assets/images/other-images/sad.png" alt="" />
          <div className="error-heading">
            <h2 className="headline font-info">404</h2>
          </div>
          <div className="col-md-8 offset-md-2">
            <p className="sub-content">The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved.</p>
          </div>
          <div><Link to="/" className="btn btn-info-gradien btn-lg">BACK TO HOME PAGE</Link></div>
        </div>
      </div>
        </>
    )
}

export default NotFound
